export const config = {
  title: "All Florida Roofing LLC | Roofing Contractors in Jacksonville, FL",
  meta: {
    description:
      "All Florida Roofing LLC provides expert residential and commercial roofing services in Jacksonville, FL. Specializing in installations, repairs, replacements, and storm damage restoration with over 31 years of experience.",
    keywords: [
      "All Florida Roofing LLC",
      "roofing Jacksonville",
      "roof repair Jacksonville",
      "roof replacement Jacksonville",
      "storm damage repair",
      "metal roofing",
      "shingle roofing",
      "flat roofing"
    ],
    author: "All Florida Roofing LLC",
    canonicalUrl: "https://allfloridaroofingllc.com/",
  },
  sections: {
    header: {
      businessName: "All Florida Roofing LLC",
    },
    sectionB: {
      heroTitle: "Protecting Your Home with Quality Roofing",
      heroSubtitle: "Trusted Roofing Experts Serving Jacksonville & the First Coast",
      learnAboutText: "Get a Free Estimate",
      phoneNumber: "9048322384",
      phoneLabel: "(904) 832-2384",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1148223953/photo/front-closeup-of-house-during-day-over-garage-with-gray-color-single-family-home-and-roof.jpg?s=612x612&w=0&k=20&c=1hQ8u9GJA7P1H_1CYz7sjCowA6HOWMuDPlonS4WnAgM=",
      cardData: [
        {
          title: "Roof Installation",
          description:
            "New roof installations built above Florida's code requirements for lasting protection.",
        },
        {
          title: "Roof Repair",
          description:
            "Quick and efficient repairs to restore the integrity of your roof and prevent future issues.",
        },
        {
          title: "Storm Damage Restoration",
          description:
            "Fast storm damage assessments and repairs to secure your home after harsh weather.",
        },
      ],
      description:
        "With over 31 years of experience, All Florida Roofing LLC specializes in residential and commercial roofing solutions across Jacksonville, Duval, Nassau, Clay, and Baker counties. We are locally owned, licensed, and insured, offering a 10-year workmanship warranty.",
    },
    sectionC: {
      servicesTitle: "Our Roofing Services",
      servicesDescription:
        "Comprehensive roofing services designed to protect and enhance your property.",
      cards: [
        {
          title: "Roof Installation",
          description:
            "Durable new roofs for homes and businesses built with quality materials.",
          imageSrc: "https://media.istockphoto.com/id/2193961776/photo/aerial-view-of-solar-energy-technicians-working-to-install-solar-panels-on-residential-roof.jpg?s=612x612&w=0&k=20&c=uVu-wCjfqraG6f7MRBNXSFOCHurbGW0OVb5PjpbKcxI=",
          imageAlt: "Roof Installation",
        },
        {
          title: "Roof Repair",
          description:
            "From minor leaks to major damage, our team ensures efficient, lasting repairs.",
          imageSrc: "https://media.istockphoto.com/id/2156501258/photo/damaged-house-roof-with-missing-shingles-after-hurricane-ian-in-florida-consequences-of.jpg?s=612x612&w=0&k=20&c=PHfzobW5JfhnX5iIB_1-gyK73dTk3gOfrsNUb0UPLmQ=",
          imageAlt: "Roof Repair",
        },
        {
          title: "Roof Replacement",
          description:
            "Expert re-roofing solutions to upgrade your home's protection and value.",
          imageSrc: "https://media.istockphoto.com/id/2160402560/photo/construction-worker-is-inspecting-roof-tile-cracked.jpg?s=612x612&w=0&k=20&c=xlJhNN05zKhnGXrZRYiStTPKwri2vdvY7YtSIgUanXw=",
          imageAlt: "Roof Replacement",
        },
      ],
      otherServicesTitle: "Other Services",
      otherServicesList: [
        "Storm Damage Repair",
        "Shingle, Metal & Flat Roofing",
        "Commercial Roofing",
        "Free Estimates",
        "10-Year Workmanship Warranty",
      ],
    },
    sectionD: {
      aboutTitle: "About All Florida Roofing LLC",
      aboutImage: {
        src: "https://media.istockphoto.com/id/157378455/photo/home-repairs-handyman-up-a-ladder-outdoors.jpg?s=612x612&w=0&k=20&c=z_YqWun9ITOK_Pv7l8qPzeWyK2w-nmaE88vdRUJ3nVY=",
        alt: "All Florida Roofing Team",
      },
      aboutText: [
        "All Florida Roofing LLC is a family-owned, second-generation roofing company serving Jacksonville, FL and surrounding areas for over 31 years.",
        "We are fully licensed and insured (LIC #CCC057820), committed to superior craftsmanship, transparency, and customer satisfaction, backed by a 10-year workmanship warranty.",
      ],
    },
    sectionE: {
      profileImage: "https://static.mywebsites360.com/a7080b236fb04e2691b04cb648c8e205/i/b2eff03ff968400d96ea061590949623/1/5feFb8zhrk/M337211%20-%20Logo.png",
      profileAlt: "All Florida Roofing LLC Logo",
      businessName: "All Florida Roofing LLC",
      contact: {
        phone: "9048322384",
        phoneLabel: "(904) 832-2384",
        email: "rooflife99@yahoo.com",
        website: "https://allfloridaroofingllc.com/",
        address: "Jacksonville, FL 32220",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedIn: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: "Jacksonville, FL 32220",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d344352.8854568188!2d-81.8011786934106!3d30.348898058990888!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e5b84b9a3a6f71%3A0xa01384a30d3f9f01!2sJacksonville%2C%20FL%2032220!5e0!3m2!1sen!2sus!4v1714567890123!5m2!1sen!2sus",
    },
  },
};

export default config;